import styled from 'styled-components'

export const PanelRoot = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  border-top: 0.0625rem solid #e3e3e3;
  padding-top: 1.5rem;
`

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.grey900Color};
`

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  gap: 0.75rem;
`

export const SparklineGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
`

export const ChartGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
`

export const ChartCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem 1.125rem;
  border: 1px solid ${({ theme }) => theme.grey400Color};
  border-radius: 0.5rem;
  background: ${({ theme }) => theme.whiteColor};
`

export const ChartTitle = styled.span`
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.grey900Color};
`
